// NPM Imports
import { combineReducers } from "redux";

// Internal Imports
import AssetStore from "./AssetReducer";
import OldAssetStore from "./AssetsReducer";
import AuthStore from "./AuthReducer";
import CommonStore from "./CommonReducer";
import DashboardStore from "./DashboardReducer";
import DealTableStore from "./DealTableReducer";
import DocumentDealTableReducer from "./DocumentDealTableReducer";
import DocumentStore from "./DocumentReducer";
import GoogleSheetStore from "./GoogleSheetReducer";
import EditorStore from "./EditorReducer";
import InboxStore from "./InboxReducer";
import KanbanStore from "./KanbanReducer";
import MetalensStore from "./MetalensReducer";
import NavBarStore from "./NavBarReducer";
import NotesStore from "./NotesReducer";
import OnboardingModalStore from "./OnboardingModalReducer";
import OpportunitiesStore from "./OpportunitiesReducer";
import PipelineStore from "./PipelineReducer";
import PricebookStore from "./PricebookReducer";
import ProductsStore from "./ProductReducer";
import QuotationStore from "./QuotationReducer";
import QuoteDocumentStore from "./QuoteDocumentReducer";
import QuotesStore from "./QuotesReducer";
import SettingsStore from "./SettingsReducer";
import SharedDocument from "./DocumentSharedReducer";
import TemplateStore from "./TemplateReducer";
import ToolPaneStore from "./ToolPaneReducer";
import WorkFlowStore from "./WorkFlowReducer";
import NavbarWrapperStore from "./NavbarWrapperReducer";

export default combineReducers({
  AssetStore,
  OldAssetStore,
  AuthStore,
  CommonStore,
  DashboardStore,
  DealTableStore,
  DocumentDealTableReducer,
  DocumentStore,
  GoogleSheetStore,
  EditorStore,
  InboxStore,
  KanbanStore,
  MetalensStore,
  NavBarStore,
  NavbarWrapperStore,
  NotesStore,
  OnboardingModalStore,
  OpportunitiesStore,
  PipelineStore,
  PricebookStore,
  ProductsStore,
  QuotationStore,
  QuoteDocumentStore,
  QuotesStore,
  SettingsStore,
  SharedDocument,
  TemplateStore,
  ToolPaneStore,
  WorkFlowStore,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js